var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEditLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.640348 11.9949C0.640348 11.9949 0.709562 11.9949 0.735517 11.9949L2.86383 11.6662L4.62012 11.3893C4.74989 11.372 4.87967 11.3028 4.97484 11.2076L10.6503 5.53212L11.4722 4.71021C11.8097 4.37279 12 3.92291 12 3.43841C12 2.95392 11.8097 2.50403 11.4722 2.16662L9.83708 0.531449C9.1363 -0.169337 7.99427 -0.169337 7.30214 0.531449L6.48023 1.35336L0.796078 7.02886C0.70091 7.12403 0.640348 7.24515 0.614393 7.38358L0.00877576 11.2595C-0.0258309 11.4585 0.0433825 11.6662 0.190461 11.8046C0.311584 11.9257 0.475966 11.9949 0.640348 11.9949ZM8.19326 1.42257C8.4009 1.21493 8.72967 1.21493 8.93731 1.42257L10.5725 3.05774C10.6676 3.15291 10.7282 3.29133 10.7282 3.42976C10.7282 3.56819 10.6763 3.69796 10.5725 3.80178L10.2005 4.1738L9.00652 2.97987L7.81259 1.78594L8.18461 1.41392L8.19326 1.42257ZM1.84293 7.78155L6.92147 2.69437L9.30068 5.07358L4.22214 10.1521L2.9936 10.3425L1.65259 9.00144L1.84293 7.7729V7.78155Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditLight);
export default __webpack_public_path__ + "static/media/ico-edit-light.41a82a0ba94706ed69e01834dbab4d8a.svg";
export { ForwardRef as ReactComponent };